import tempMeeApi from '../../../apis/tempMee';

/**
 * One office's whole promo history: `GET /v1/admin/offices/:officeId/discounts`
 * (campaign-service PR #79, GOTU-6598).
 *
 * Redemption-scoped rather than opt-in-scoped, which is why this route and not
 * the sibling `/applied-codes`: a discount an automatic campaign granted without
 * minting an opt-in row still shows up here. An office with no history is a 200
 * with an empty `history` array, not a 404.
 */
export const getOfficeDiscountHistory = async (officeId) => {
  const response = await tempMeeApi.get(
    `/campaign-service/v1/admin/offices/${officeId}/discounts`,
  );

  return response.data;
};
